<template>
  <button class="Btn-Up" :class="get_classModify" @click="toScroll">
    <svg class="Btn-Up__svg" width="24" height="24" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <path class="Btn-Up__fill" fill-rule="evenodd" clip-rule="evenodd" d="M2.86323 5.52827C3.12358 5.26792 3.54569 5.26792 3.80604 5.52827L8.0013 9.72353L12.1966 5.52827C12.4569 5.26792 12.879 5.26792 13.1394 5.52827C13.3997 5.78862 13.3997 6.21073 13.1394 6.47108L8.47271 11.1377C8.21236 11.3981 7.79025 11.3981 7.5299 11.1377L2.86323 6.47108C2.60288 6.21073 2.60288 5.78862 2.86323 5.52827Z"></path>
    </svg>
  </button>
</template>

<script setup>
  import { computed } from 'vue';
  import { Props } from './scripts/props.js';
  //----------------------
  const props = defineProps(Props());
  //----------------------
  const get_classModify = computed(() => `Btn-Up--${props.type}`);
  //----------------------
  const toScroll = () => {
    props.selector.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
</script>

<style lang="scss">
  @import "./styles/_style";
</style>